window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance(container, constructor) {
    const $container = $(container);
    const id = $container.attr('data-section-id');
    const type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    const instance = _.assignIn(new constructor(container), {
      id,
      type,
      container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad(evt) {
    const container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload(evt) {
    this.instances = _.filter(this.instances, (instance) => {
      const isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, (instance) => {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, (instance) => {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, (instance) => {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, (instance) => {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register(type, constructor) {
    this.constructors[type] = constructor;

    $(`[data-section-type=${type}]`).each(
      (index, container) => {
        this._createInstance(container, constructor);
      },
    );
      },
      });

    window.slate = window.slate || {};

    /**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

    slate.utils = {

      /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
      getParameterByName(name, url) {
        if (!url) { url = window.location.href; }
        name = name.replace(/[[\]]/g, '\\$&');
        const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
        const results = regex.exec(url);
        if (!results) { return null; }
        if (!results[2]) { return ''; }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },

      keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39,
      },
    };

    window.slate = window.slate || {};

    /**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

    slate.rte = {

      /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
      wrapTable(options) {
        options.$tables.wrap(
          `<div class="${options.tableWrapperClass}"></div>`,
        );
          },

          /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
          wrapIframe(options) {
          options.$iframes.each(function() {
            // Add wrapper to make video responsive
            $(this).wrap(`<div class="${options.iframeWrapperClass}"></div>`);

            // Re-set the src attribute on each iframe after page load
            // for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791
            // Need to specifically target video and admin bar
            this.src = this.src;
          });
        },
      };

      window.slate = window.slate || {};

    /**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

    slate.a11y = {

      /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
      pageLinkFocus($element) {
        const focusClass = 'js-focus-hidden';

        $element
        .first()
        .attr('tabIndex', '-1')
        .focus()
        .addClass(focusClass)
        .one('blur', callback);

        function callback() {
          $element
          .first()
          .removeClass(focusClass)
          .removeAttr('tabindex');
        }
      },

      /**
   * If there's a hash in the url, focus the appropriate element
   */
      focusHash() {
        const hash = window.location.hash;

        // is there a hash in the url? is it an element on the page?
        if (hash && document.getElementById(hash.slice(1))) {
          this.pageLinkFocus($(hash));
        }
      },

      /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
      bindInPageLinks() {
        $('a[href*=#]').on(
          'click',
          (evt) => {
            this.pageLinkFocus($(evt.currentTarget.hash));
          },
        );
          },

          /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
          trapFocus(options) {
          const eventsName = {
            focusin: options.namespace ? `focusin.${options.namespace}` : 'focusin',
            focusout: options.namespace
            ? `focusout.${options.namespace}`
            : 'focusout',
            keydown: options.namespace
            ? `keydown.${options.namespace}`
            : 'keydown.handleFocus',
          };

          /**
     * Get every possible visible focusable element
     */
          const $focusableElements = options.$container.find(
            $(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
            ).filter(':visible'),
          );
            const firstFocusable = $focusableElements[0];
            const lastFocusable = $focusableElements[$focusableElements.length - 1];

            if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
          }

          function _manageFocus(evt) {
            if (evt.keyCode !== slate.utils.keyboardKeys.TAB) { return; }

            /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
            if (evt.target === lastFocusable && !evt.shiftKey) {
              evt.preventDefault();
              firstFocusable.focus();
            }

            /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
            if (evt.target === firstFocusable && evt.shiftKey) {
              evt.preventDefault();
              lastFocusable.focus();
            }
          }

          options.$container.attr('tabindex', '-1');
          options.$elementToFocus.focus();

          $(document).off('focusin');

          $(document).on(eventsName.focusout, () => {
                         $(document).off(eventsName.keydown);
        });

        $(document).on(eventsName.focusin, (evt) => {
          if (evt.target !== lastFocusable && evt.target !== firstFocusable) { return; }

          $(document).on(eventsName.keydown, (evt) => {
            _manageFocus(evt);
          });
        });
      },

      /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
      removeTrapFocus(options) {
        const eventName = options.namespace
        ? `focusin.${options.namespace}`
        : 'focusin';

        if (options.$container && options.$container.length) {
          options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
      },

      /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
      accessibleLinks(options) {
        const body = document.querySelector('body');

        const idSelectors = {
          newWindow: 'a11y-new-window-message',
          external: 'a11y-external-message',
          newWindowExternal: 'a11y-new-window-external-message',
        };

        if (options.$links === undefined || !options.$links.jquery) {
          options.$links = $('a[href]:not([aria-describedby])');
        }

        function generateHTML(customMessages) {
          if (typeof customMessages !== 'object') {
            customMessages = {};
          }

          const messages = $.extend(
            {
              newWindow: 'Opens in a new window.',
              external: 'Opens external website.',
              newWindowExternal: 'Opens external website in a new window.',
            },
            customMessages,
          );

            const container = document.createElement('ul');
          let htmlMessages = '';

          for (const message in messages) {
            htmlMessages +=
              `<li id=${idSelectors[message]}>${messages[message]}</li>`;
          }

          container.setAttribute('hidden', true);
          container.innerHTML = htmlMessages;

          body.appendChild(container);
        }

        function _externalSite($link) {
          const hostname = window.location.hostname;

          return $link[0].hostname !== hostname;
        }

        $.each(options.$links, function() {
          const $link = $(this);
          const target = $link.attr('target');
          const rel = $link.attr('rel');
          const isExternal = _externalSite($link);
          const isTargetBlank = target === '_blank';

          if (isExternal) {
            $link.attr('aria-describedby', idSelectors.external);
          }
          if (isTargetBlank) {
            if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function(i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
            $link.attr('aria-describedby', idSelectors.newWindow);
          }
          if (isExternal && isTargetBlank) {
            $link.attr('aria-describedby', idSelectors.newWindowExternal);
          }
        });

        generateHTML(options.messages);
      },
    };

    /**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

    theme.Images = (function() {

      /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

      function preload(images, size) {
        if (typeof images === 'string') {
          images = [images];
        }

        for (let i = 0; i < images.length; i++) {
          const image = images[i];
          this.loadImage(this.getSizedImageUrl(image, size));
        }
      }

      /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
      function loadImage(path) {
        new Image().src = path;
      }

      /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
      function switchImage(image, element, callback) {
        const size = this.imageSize(element.src);
        const imageUrl = this.getSizedImageUrl(image.src, size);

        if (callback) {
          callback(imageUrl, image, element); // eslint-disable-line callback-return
        } else {
          element.src = imageUrl;
        }
      }

      /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
      function imageSize(src) {
        const match = src.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/,
        );

          if (match !== null) {
          if (match[2] !== undefined) {
            return match[1] + match[2];
          } else {
            return match[1];
          }
        } else {
          return null;
        }
      }

      /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
      function getSizedImageUrl(src, size) {
        if (size === null) {
          return src;
        }

        if (size === 'master') {
          return this.removeProtocol(src);
        }

        const match = src.match(
          /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i,
        );

          if (match !== null) {
          const prefix = src.split(match[0]);
          const suffix = match[0];

          return this.removeProtocol(`${prefix[0]}_${size}${suffix}`);
        }

        return null;
      }

      function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
      }

      return {
        preload,
        loadImage,
        switchImage,
        imageSize,
        getSizedImageUrl,
        removeProtocol,
      };
    })();

    /**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

    theme.Currency = (function() {
      const moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ',';
          decimal = decimal || '.';

          if (isNaN(number) || number === null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          const parts = number.split('.');
          const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`,
          );
            const centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount;
            }

            switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
            case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
            case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
            case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
            case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
            case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
          }

          return formatString.replace(placeholderRegex, value);
        }

        return {
          formatMoney,
        };
      })();

      /**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

      slate.Variants = (function() {

        /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
        function Variants(options) {
          this.$container = options.$container;
          this.product = options.product;
          this.singleOptionSelector = options.singleOptionSelector;
          this.originalSelectorId = options.originalSelectorId;
          this.enableHistoryState = options.enableHistoryState;
          this.currentVariant = this._getVariantFromOptions();

          $(this.singleOptionSelector, this.$container).on(
            'change',
            this._onSelectChange.bind(this),
          );
            }

            Variants.prototype = _.assignIn({}, Variants.prototype, {

            /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
            _getCurrentOptions() {
            let currentOptions = _.map(
              $(this.singleOptionSelector, this.$container),
              (element) => {
                const $element = $(element);
                const type = $element.attr('type');
                const currentOption = {};

                if (type === 'radio' || type === 'checkbox') {
                  if ($element[0].checked) {
                    currentOption.value = $element.val();
                    currentOption.index = $element.data('index');

                    return currentOption;
                  } else {
                    return false;
                  }
                } else {
                  currentOption.value = $element.val();
                  currentOption.index = $element.data('index');

                  return currentOption;
                }
              },
            );

              // remove any unchecked input values if using radio buttons or checkboxes
              currentOptions = _.compact(currentOptions);

            return currentOptions;
          },

            /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
            _getVariantFromOptions() {
              const selectedValues = this._getCurrentOptions();
              const variants = this.product.variants;

              const found = _.find(variants, (variant) => {
                return selectedValues.every((values) => {
                  return _.isEqual(variant[values.index], values.value);
                });
              });

              return found;
            },

              /**
     * Event handler for when a variant input changes.
     */
              _onSelectChange() {
                const variant = this._getVariantFromOptions();

                this.$container.trigger({
                  type: 'variantChange',
                  variant,
                });

                if (!variant) {
                  return;
                }

                this._updateMasterSelect(variant);
                this._updateImages(variant);
                this._updatePrice(variant);
                this._updateSKU(variant);
                this.currentVariant = variant;

                if (this.enableHistoryState) {
                  this._updateHistoryState(variant);
                }
              },

                /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
                _updateImages(variant) {
                  const variantImage = variant.featured_image || {};
                  const currentVariantImage = this.currentVariant.featured_image || {};

                  if (
                    !variant.featured_image ||
                    variantImage.src === currentVariantImage.src
                  ) {
                    return;
                  }

                  this.$container.trigger({
                    type: 'variantImageChange',
                    variant,
                  });
                },

                  /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
                  _updatePrice(variant) {
                    if (
                      variant.price === this.currentVariant.price &&
                      variant.compare_at_price === this.currentVariant.compare_at_price
                    ) {
                      return;
                    }

                    this.$container.trigger({
                      type: 'variantPriceChange',
                      variant,
                    });
                  },

                    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
                    _updateSKU(variant) {
                      if (variant.sku === this.currentVariant.sku) {
                        return;
                      }

                      this.$container.trigger({
                        type: 'variantSKUChange',
                        variant,
                      });
                    },

                      /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
                      _updateHistoryState(variant) {
                        if (!history.replaceState || !variant) {
                          return;
                        }

                        const newurl =
                              `${window.location.protocol
                        }//${
                        window.location.host
                        }${window.location.pathname
                        }?variant=${
                        variant.id}`;
                        window.history.replaceState({path: newurl}, '', newurl);
                      },

                        /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
                        _updateMasterSelect(variant) {
                          $(this.originalSelectorId, this.$container).val(variant.id);
                        },
        });

        return Variants;
      })();


      /* ================ GLOBAL ================ */
      /*= ===========================================================================
  Drawer modules
==============================================================================*/
      theme.Drawers = (function() {
        function Drawer(id, position, options) {
          const defaults = {
            close: '.js-drawer-close',
            open: `.js-drawer-open-${position}`,
            openClass: 'js-drawer-open',
            dirOpenClass: `js-drawer-open-${position}`,
          };

          this.nodes = {
            $parent: $('html').add('body'),
            $page: $('#PageContainer'),
          };

          this.config = $.extend(defaults, options);
          this.position = position;

          this.$drawer = $(`#${id}`);

          if (!this.$drawer.length) {
            return false;
          }

          this.drawerIsOpen = false;
          this.init();
        }

        Drawer.prototype.init = function() {
          $(this.config.open).on('click', $.proxy(this.open, this));
          this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
        };

        Drawer.prototype.open = function(evt) {
          // Keep track if drawer was opened from a click, or called by another function
          let externalCall = false;

          // Prevent following href if link is clicked
          if (evt) {
            evt.preventDefault();
          } else {
            externalCall = true;
          }

          // Without this, the drawer opens, the click event bubbles up to nodes.$page
          // which closes the drawer.
          if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            this.$activeSource = $(evt.currentTarget);
          }

          if (this.drawerIsOpen && !externalCall) {
            return this.close();
          }

          // Add is-transitioning class to moved elements on open so drawer can have
          // transition for close animation
          this.$drawer.prepareTransition();

          this.nodes.$parent.addClass(
            `${this.config.openClass} ${this.config.dirOpenClass}`,
          );
            this.drawerIsOpen = true;

            // Set focus on drawer
            slate.a11y.trapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus',
            });

          // Run function when draw opens if set
          if (
            this.config.onDrawerOpen &&
            typeof this.config.onDrawerOpen === 'function'
          ) {
            if (!externalCall) {
              this.config.onDrawerOpen();
            }
          }

          if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true');
          }

          this.bindEvents();

          return this;
        };

        Drawer.prototype.close = function() {
          if (!this.drawerIsOpen) {
            // don't close a closed drawer
            return;
          }

          // deselect any focused form elements
          $(document.activeElement).trigger('blur');

          // Ensure closing transition is applied to moved elements, like the nav
          this.$drawer.prepareTransition();

          this.nodes.$parent.removeClass(
            `${this.config.dirOpenClass} ${this.config.openClass}`,
          );

            if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'false');
          }

          this.drawerIsOpen = false;

          // Remove focus on drawer
          slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: 'drawer_focus',
          });

          this.unbindEvents();

          // Run function when draw closes if set
          if (
            this.config.onDrawerClose &&
            typeof this.config.onDrawerClose === 'function'
          ) {
            this.config.onDrawerClose();
          }
        };

        Drawer.prototype.bindEvents = function() {
          this.nodes.$parent.on(
            'keyup.drawer',
            $.proxy(function(evt) {
              // close on 'esc' keypress
              if (evt.keyCode === 27) {
                this.close();
                return false;
              } else {
                return true;
              }
            }, this),
          );

            // Lock scrolling on mobile
            this.nodes.$page.on('touchmove.drawer', () => {
            return false;
          });

          this.nodes.$page.on(
            'click.drawer',
            $.proxy(function() {
              this.close();
              return false;
            }, this),
          );
            };

            Drawer.prototype.unbindEvents = function() {
            this.nodes.$page.off('.drawer');
            this.nodes.$parent.off('.drawer');
          };

          return Drawer;
        })();


        /* ================ MODULES ================ */
        window.theme = window.theme || {};

        theme.Header = (function() {
          const selectors = {
            body: 'body',
            multicurrencySelector: '[data-currency-selector]',
            navigation: '#AccessibleNav',
            siteNavHasDropdown: '[data-has-dropdowns]',
            siteNavChildLinks: '.site-nav__child-link',
            siteNavActiveDropdown: '.site-nav--active-dropdown',
            siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
            siteNavCenteredDropdown: '.site-nav__dropdown--centered',
            siteNavLinkMain: '.site-nav__link--main',
            siteNavChildLink: '.site-nav__link--last',
            siteNavDropdown: '.site-nav__dropdown',
            siteHeader: '.site-header',
          };

          const config = {
            activeClass: 'site-nav--active-dropdown',
            childLinkClass: 'site-nav__child-link',
            rightDropdownClass: 'site-nav__dropdown--right',
            leftDropdownClass: 'site-nav__dropdown--left',
          };

          let cache = {};

          function init() {
            cacheSelectors();
            styleDropdowns($(selectors.siteNavHasDropdown));
            positionFullWidthDropdowns();

            cache.$parents.on('click.siteNav', function() {
              const $el = $(this);
              $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
            });

            // check when we're leaving a dropdown and close the active dropdown
            $(selectors.siteNavChildLink).on('focusout.siteNav', () => {
                                             setTimeout(() => {
              if (
                $(document.activeElement).hasClass(config.childLinkClass) ||
                !cache.$activeDropdown.length
              ) {
                return;
              }

              hideDropdown(cache.$activeDropdown);
            });
          });

          // close dropdowns when on top level nav
          cache.$topLevel.on('focus.siteNav', () => {
                             if (cache.$activeDropdown.length) {
            hideDropdown(cache.$activeDropdown);
          }
        });

        cache.$subMenuLinks.on('click.siteNav', (evt) => {
          // Prevent click on body from firing instead of link
          evt.stopImmediatePropagation();
        });
            cacheSelectors();
            styleDropdowns($(selectors.siteNavHasDropdown));
            positionFullWidthDropdowns();

            cache.$parents.on('click.siteNav', function() {
              const $el = $(this);
              $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
            });

            // check when we're leaving a dropdown and close the active dropdown
            $(selectors.siteNavChildLink).on('focusout.siteNav', () => {
                                             setTimeout(() => {
              if (
                $(document.activeElement).hasClass(config.childLinkClass) ||
                !cache.$activeDropdown.length
              ) {
                return;
              }

              hideDropdown(cache.$activeDropdown);
            });
          });

          // close dropdowns when on top level nav
          cache.$topLevel.on('focus.siteNav', () => {
                             if (cache.$activeDropdown.length) {
            hideDropdown(cache.$activeDropdown);
          }
        });

        cache.$subMenuLinks.on('click.siteNav', (evt) => {
          // Prevent click on body from firing instead of link
          evt.stopImmediatePropagation();
        });

        $(selectors.multicurrencySelector).on('change', function() {
          $(this)
          .parents('form')
          .submit();
        });

        $(window).resize(
          $.debounce(50, () => {
                     styleDropdowns($(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
      }),
        );
    }

                      function cacheSelectors() {
      cache = {
        $nav: $(selectors.navigation),
        $topLevel: $(selectors.siteNavLinkMain),
        $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
        $subMenuLinks: $(selectors.siteNavChildLinks),
        $activeDropdown: $(selectors.siteNavActiveDropdown),
        $siteHeader: $(selectors.siteHeader),
      };
    }

    function showDropdown($el) {
      $el.addClass(config.activeClass);

      // close open dropdowns
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }

      cache.$activeDropdown = $el;

      // set expanded on open dropdown
      $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

      setTimeout(() => {
                 $(window).on('keyup.siteNav', (evt) => {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', () => {
                           hideDropdown($el);
    });
  }, 250);
}

                                      function hideDropdown($el) {
  // remove aria on open dropdown
  $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
  $el.removeClass(config.activeClass);

  // reset active dropdown
  cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

  $(selectors.body).off('click.siteNav');
  $(window).off('keyup.siteNav');
}

function styleDropdowns($dropdownListItems) {
  $dropdownListItems.each(function() {
    const $dropdownLi = $(this).find(selectors.siteNavDropdown);
    if (!$dropdownLi.length) {
      return;
    }
    const isRightOfLogo =
          Math.ceil($(this).offset().left) >
          Math.floor(cache.$siteHeader.outerWidth()) / 2;
    if (isRightOfLogo) {
      $dropdownLi
      .removeClass(config.leftDropdownClass)
      .addClass(config.rightDropdownClass);
    } else {
      $dropdownLi
      .removeClass(config.rightDropdownClass)
      .addClass(config.leftDropdownClass);
    }
  });
}

function positionFullWidthDropdowns() {
  const $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);

  $listWithCenteredDropdown.each(function() {
    const $hasCenteredDropdown = $(this);
    const $fullWidthDropdown = $hasCenteredDropdown.find(
      selectors.siteNavCenteredDropdown,
    );

      const fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41;
    $fullWidthDropdown.css('top', fullWidthDropdownOffset);
  });
}

function unload() {
  $(window).off('.siteNav');
  cache.$parents.off('.siteNav');
  cache.$subMenuLinks.off('.siteNav');
  cache.$topLevel.off('.siteNav');
  $(selectors.siteNavChildLink).off('.siteNav');
  $(selectors.body).off('.siteNav');
}

return {
  init,
  unload,
};
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  const classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu',
  };
  let cache = {};
  let isTransitioning;
  let $activeSubNav;
  let $activeTrigger;
  let menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  const mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      },
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $(`.${classes.subNavToggleBtn}`),
    };
  }

  function openMobileNav() {
    const translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: `translateY(${translateHeaderHeight}px)`,
    });

    cache.$pageContainer.css({
      transform:
      `translate3d(0, ${cache.$mobileNavContainer[0].scrollHeight}px, 0)`,
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus',
    });

    cache.$mobileNavToggle
    .addClass(classes.mobileNavCloseIcon)
    .removeClass(classes.mobileNavOpenIcon)
    .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', (evt) => {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)',
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body'),
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      () => {
      slate.a11y.removeTrapFocus({
      $container: cache.$mobileNav,
      namespace: 'navFocus',
      });
  },
    );

  cache.$mobileNavToggle
  .addClass(classes.mobileNavOpenIcon)
  .removeClass(classes.mobileNavCloseIcon)
  .attr('aria-expanded', false)
  .focus();

  $(window).off('keyup.mobileNav');

  scrollTo(0, 0);
}

                   function toggleSubNav(evt) {
  if (isTransitioning) {
    return;
  }

  const $toggleBtn = $(evt.currentTarget);
  const isReturn = $toggleBtn.hasClass(classes.return);
  isTransitioning = true;

  if (isReturn) {
    // Close all subnavs by removing active class on buttons
    $(
      `.${classes.subNavToggleBtn}[data-level="${menuLevel - 1}"]`,
    ).removeClass(classes.subNavActive);

    if ($activeTrigger && $activeTrigger.length) {
      $activeTrigger.removeClass(classes.subNavActive);
    }
  } else {
    $toggleBtn.addClass(classes.subNavActive);
  }

  $activeTrigger = $toggleBtn;

  goToSubnav($toggleBtn.data('target'));
}

function goToSubnav(target) {
  /* eslint-disable shopify/jquery-dollar-sign-reference */

  const $targetMenu = target
  ? $(`.mobile-nav__dropdown[data-parent="${target}"]`)
  : cache.$mobileNav;

  menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

  if ($activeSubNav && $activeSubNav.length) {
    $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
  }

  $activeSubNav = $targetMenu;

  /* eslint-enable shopify/jquery-dollar-sign-reference */

  const translateMenuHeight = $targetMenu.outerHeight();

  const openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

  cache.$mobileNavContainer
  .css('height', translateMenuHeight)
  .removeClass(classes.thirdNavShowing)
  .addClass(openNavClass);

  if (!target) {
    // Show top level nav
    cache.$mobileNavContainer
    .removeClass(classes.thirdNavShowing)
    .removeClass(classes.subNavShowing);
  }

  /* if going back to first subnav, focus is on whole header */
  const $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

  const $menuTitle = $targetMenu.find(`[data-menu-title=${menuLevel}]`);
  const $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

  // Focusing an item in the subnav early forces element into view and breaks the animation.
  cache.$mobileNavContainer.one(
    'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
    () => {
    slate.a11y.trapFocus({
    $container,
    $elementToFocus,
    namespace: 'subNavFocus',
    });

  cache.$mobileNavContainer.off('.subnavToggle');
  isTransitioning = false;
},
  );

// Match height of subnav
cache.$pageContainer.css({
  transform: `translateY(${translateMenuHeight}px)`,
});

$activeSubNav.removeClass(classes.subNavClosing);
}

return {
  init,
  closeMobileNav,
};
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  const selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper',
  };

  const classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open',
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    const isSearchPage =
          slate.utils.getParameterByName('q') !== null &&
          window.location.pathname === '/search';

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this),
    );

      $(selectors.searchHeaderInput)
    .add(selectors.searchHeaderSubmit)
    .on('focus blur', () => {
        $(selectors.searchHeader).toggleClass(classes.focus);
    //         $('.header__additional-text').toggleClass('hide');
  });

  $(selectors.siteHeaderSearchToggle).on('click', () => {
                                         const searchHeight = $(selectors.siteHeader).outerHeight();
  const searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

  $(selectors.searchDrawer).css({
    height: `${searchHeight}px`,
    top: `${searchOffset}px`,
  });
});
}

function initDrawer() {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');
  $('.js-drawer-open-top')
  .attr('aria-controls', 'SearchDrawer')
  .attr('aria-expanded', 'false')
  .attr('aria-haspopup', 'dialog');

  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
    onDrawerOpen: searchDrawerFocus,
    onDrawerClose: searchDrawerFocusClose,
  });
}

function searchDrawerFocus() {
  searchFocus($(selectors.searchDrawerInput));

  if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
    theme.MobileNav.closeMobileNav();
  }
}

function searchFocus($el) {
  $el.focus();
  // set selection range hack for iOS
  $el[0].setSelectionRange(0, $el[0].value.length);
}

function searchDrawerFocusClose() {
  $(selectors.siteHeaderSearchToggle).focus();
}

/**
   * Remove the aria-attributes and hide the error messages
   */
function hideErrorMessage() {
  this.$searchErrorMessage.addClass(classes.hidden);
  this.$searchResultInput
  .removeAttr('aria-describedby')
  .removeAttr('aria-invalid');
}

/**
   * Add the aria-attributes and show the error messages
   */
function showErrorMessage() {
  this.$searchErrorMessage.removeClass(classes.hidden);
  this.$searchResultInput
  .attr('aria-describedby', 'error-search-form')
  .attr('aria-invalid', true);
}

function validateSearchResultForm(evt) {
  const isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

  if (!isInputValueEmpty) {
    hideErrorMessage.call(this);
    return;
  }

  if (typeof evt !== 'undefined') {
    evt.preventDefault();
  }

  searchFocus(this.$searchResultInput);
  showErrorMessage.call(this);
}

return {
  init,
};
})();

(function() {
  const selectors = {
    backButton: '.return-link',
  };

  const $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', (evt) => {
    evt.preventDefault();

    const referrerDomain = urlDomain(document.referrer);
    const shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    const anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  const classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused',
  };

  const selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    pauseButton: '.slideshow__pause',
    dots: '.slick-dots',
    arrows: '.slideshow__arrows',
    arrowsMobile: '.slideshow__arrows--mobile',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right',
  };

  function slideshow(el, sectionId) {
    const $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$arrows = this.$section.find(selectors.arrows);
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
    this.$pause = this.$controls.find(selectors.pauseButton);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    const autoplaySpeed = this.$slideshow.data('speed');
    const loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');

    this.settings = {
      infinite: true,
      centerMode: true,
      centerPadding: '70px',
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      appendDots: this.$arrows,
      customPaging(slick, index) {
      return (
      `<a href="${
      selectors.wrapper
    }${sectionId
      }" aria-label="${
        loadSlideA11yString.replace('[slide_number]', index + 1)
      }" data-slide-number="${
        index
      }"></a>`
      );
  },
};

                   this.$slideshow.on('beforeChange', beforeChange.bind(this));
this.$slideshow.on('init', slideshowA11ySetup.bind(this));

// Add class to style mobile dots & show the correct text content for the
// first slide on mobile when the slideshow initialises
this.$slideshow.on(
  'init',
  () => {
  this.$mobileDots
  .find('li:first-of-type')
.addClass(classes.slickActiveMobile);
this.showMobileText(0);
},
  );

// Stop the autorotate when you scroll past the mobile controls, resume when
// they are scrolled back into view
if (this.autorotate) {
  $(document).scroll(
    $.debounce(
      250,
      () => {
      if (
      this.$arrowsMobile.offset().top +
    this.$arrowsMobile.outerHeight() <
    window.pageYOffset
  ) {
    $slideshow.slick('slickPause');
  } else if (!this.$pause.hasClass(classes.isPaused)) {
    $slideshow.slick('slickPlay');
  }
},
  ),
    );
}

if (this.adaptHeight) {
  this.setSlideshowHeight();
  $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
}

this.$slideshow.slick(this.settings);

// This can't be called when the slick 'init' event fires due to how slick
// adds a11y features.
slideshowPostInitA11ySetup.bind(this)();

this.$arrows.find(selectors.arrowLeft).on('click', () => {
                                          $slideshow.slick('slickPrev');
});
this.$arrows.find(selectors.arrowRight).on('click', () => {
                                           $slideshow.slick('slickNext');
});

this.$pause.on('click', this.togglePause.bind(this));
}

function slideshowA11ySetup(event, obj) {
  const $slider = obj.$slider;
  const $list = obj.$list;
  this.$dots = this.$section.find(selectors.dots);
  this.$mobileDots = this.$dots.eq(1);

  // Remove default Slick aria-live attr until slider is focused
  $list.removeAttr('aria-live');

  this.$wrapper.on('keyup', keyboardNavigation.bind(this));
  this.$controls.on('keyup', keyboardNavigation.bind(this));
  this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

  // When an element in the slider is focused
  // pause slideshow and set aria-live.
  this.$wrapper
  .on(
    'focusin',
    (evt) => {
      if (!this.$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');
      if (this.autorotate) {
        $slider.slick('slickPause');
      }
    },
  )
    .on(
    'focusout',
    (evt) => {
    if (!this.$wrapper.has(evt.target).length) {
      return;
    }

    $list.removeAttr('aria-live');
    if (this.autorotate) {
      // Only resume playing if the user hasn't paused using the pause
      // button
      if (!this.$pause.is('.is-paused')) {
        $slider.slick('slickPlay');
      }
    }
  },
    );

  // Add arrow key support when focused
  if (this.$dots) {
    this.$dots
    .find('a')
    .each(function() {
      const $dot = $(this);
      $dot.on('click keyup', (evt) => {
        if (
          evt.type === 'keyup' &&
          evt.which !== slate.utils.keyboardKeys.ENTER
        ) { return; }

        evt.preventDefault();

        const slideNumber = $(evt.target).data('slide-number');

        $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

        if (evt.type === 'keyup') {
          $slider.focus();
        }
      });
    })
    .eq(0)
    .attr('aria-current', 'true');
  }

  this.$controls
  .on('focusin', highlightControls.bind(this))
  .on('focusout', unhighlightControls.bind(this));
}

function slideshowPostInitA11ySetup() {
  const $slides = this.$slideshow.find(selectors.slides);

  $slides.removeAttr('role').removeAttr('aria-labelledby');
  this.$dots
  .removeAttr('role')
  .find('li')
  .removeAttr('role')
  .removeAttr('aria-selected')
  .each(function() {
    const $dot = $(this);
    const ariaControls = $dot.attr('aria-controls');
    $dot
    .removeAttr('aria-controls')
    .find('a')
    .attr('aria-controls', ariaControls);
  });
}

function beforeChange(event, slick, currentSlide, nextSlide) {
  const $dotLinks = this.$dots.find('a');
  const $mobileDotLinks = this.$mobileDots.find('li');

  $dotLinks
  .removeAttr('aria-current')
  .eq(nextSlide)
  .attr('aria-current', 'true');

  $mobileDotLinks
  .removeClass(classes.slickActiveMobile)
  .eq(nextSlide)
  .addClass(classes.slickActiveMobile);
  this.showMobileText(nextSlide);
}

function keyboardNavigation() {
  if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
    this.$slideshow.slick('slickPrev');
  }
  if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
    this.$slideshow.slick('slickNext');
  }
}

function highlightControls() {
  this.$controls.addClass(classes.controlsHover);
}

function unhighlightControls() {
  this.$controls.removeClass(classes.controlsHover);
}

slideshow.prototype.togglePause = function() {
  const slideshowSelector = getSlideshowId(this.$pause);
  if (this.$pause.hasClass(classes.isPaused)) {
    this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
    if (this.autorotate) {
      $(slideshowSelector).slick('slickPlay');
    }
  } else {
    this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
    if (this.autorotate) {
      $(slideshowSelector).slick('slickPause');
    }
  }
};

slideshow.prototype.setSlideshowHeight = function() {
  const minAspectRatio = this.$slideshow.data('min-aspect-ratio');
  this.$slideshow.height($(document).width() / minAspectRatio);
};

slideshow.prototype.showMobileText = function(slideIndex) {

};

function getSlideshowId($el) {
  return `#Slideshow-${$el.data('id')}`;
}

return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

theme.Video = (function() {
  let autoplayCheckComplete = false;
  let autoplayAvailable = false;
  let playOnClickChecked = false;
  let playOnClick = false;
  let youtubeLoaded = false;
  const videos = {};
  const videoPlayers = [];
  const videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  };
  const classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height',
  };

  const selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause',
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status:
      $video.data('type') === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data('type') === 'background' ? 0 : 1,
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (const key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    const videoData = videos[id];
    const player = videoPlayers[id];
    const $videoWrapper = videoData.$videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $videoWrapper);
    }
  }

  function setAutoplaySupport(supported) {
    const supportClass = supported
    ? classes.supportsAutoplay
    : classes.supportsNoAutoplay;
    $(document.documentElement)
    .removeClass(classes.supportsAutoplay)
    .removeClass(classes.supportsNoAutoplay)
    .addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    } else {
      autoplayAvailable = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $videoWrapper) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
    .then(() => {
          setAutoplaySupport(true);
  })
  .fail(() => {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
  player.stopVideo();
})
.always(() => {
        autoplayCheckComplete = true;
        $videoWrapper.removeClass(classes.loading);
});
}

function autoplayTest(player) {
  const deferred = $.Deferred();
  let wait;
  let timeout;

  wait = setInterval(() => {
                     if (player.getCurrentTime() <= 0) {
    return;
  }

  autoplayAvailable = true;
  clearInterval(wait);
  clearTimeout(timeout);
  deferred.resolve();
}, 500);

timeout = setTimeout(() => {
                     clearInterval(wait);
deferred.reject();
}, 4000); // subjective. test up to 8 times over 4 seconds

return deferred;
}

function playOnClickCheck() {
  // Bail early for a few instances:
  // - small screen
  // - device sniff mobile browser

  if (playOnClickChecked) {
    return;
  }

  if (isMobile()) {
    playOnClick = true;
  }

  if (playOnClick) {
    // No need to also do the autoplay check
    setAutoplaySupport(false);
  }

  playOnClickChecked = true;
}

// The API will call this function when each video player is ready
function onPlayerReady(evt) {
  evt.target.setPlaybackQuality('hd1080');
  const videoData = getVideoOptions(evt);
  playOnClickCheck();

  // Prevent tabbing through YouTube player controls until visible
  $(`#${videoData.id}`).attr('tabindex', '-1');

  sizeBackgroundVideos();

  // Customize based on options from the video ID
  if (videoData.type === 'background') {
    evt.target.mute();
    privatePlayVideo(videoData.id);
  }

  videoData.$videoWrapper.addClass(classes.loaded);
}

function onPlayerChange(evt) {
  const videoData = getVideoOptions(evt);
  switch (evt.data) {
    case YT.PlayerState.ENDED:
      setAsFinished(videoData);
      break;
    case YT.PlayerState.PAUSED:
      // Seeking on a YouTube video also fires a PAUSED state change,
      // checking the state after a delay prevents us pausing the video when
      // the user is seeking instead of pausing
      setTimeout(() => {
                 if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
        setAsPaused(videoData);
      }
  }, 200);
  break;
}
}

function setAsFinished(videoData) {
  switch (videoData.type) {
    case 'background':
      videoPlayers[videoData.id].seekTo(0);
      break;
    case 'image_with_play':
      closeVideo(videoData.id);
      toggleExpandVideo(videoData.id, false);
      break;
  }
}

function setAsPlaying(videoData) {
  const $videoWrapper = videoData.$videoWrapper;
  const $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);

  $videoWrapper.removeClass(classes.loading);

  if ($pauseButton.hasClass(classes.userPaused)) {
    $pauseButton.removeClass(classes.userPaused);
  }

  // Do not change element visibility if it is a background video
  if (videoData.status === 'background') {
    return;
  }

  $(`#${videoData.id}`).attr('tabindex', '0');

  if (videoData.type === 'image_with_play') {
    $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
  }

  // Update focus to the close button so we stay within the video wrapper,
  // allowing time for the scroll animation
  setTimeout(() => {
             $videoWrapper.find(selectors.closeVideoBtn).focus();
}, videoOptions.scrollAnimationDuration);
}

function setAsPaused(videoData) {
  const $videoWrapper = videoData.$videoWrapper;

  // YT's events fire after our click event. This status flag ensures
  // we don't interact with a closed or background video.
  if (videoData.type === 'image_with_play') {
    if (videoData.status === 'closed') {
      $videoWrapper.removeClass(classes.paused);
    } else {
      $videoWrapper.addClass(classes.paused);
    }
  }

  $videoWrapper.removeClass(classes.playing);
}

function closeVideo(playerId) {
  const videoData = videos[playerId];
  const $videoWrapper = videoData.$videoWrapper;
  const classesToRemove = [classes.paused, classes.playing].join(' ');

  if (isMobile()) {
    $videoWrapper.removeAttr('style');
  }

  $(`#${videoData.id}`).attr('tabindex', '-1');

  videoData.status = 'closed';

  switch (videoData.type) {
    case 'image_with_play':
      videoPlayers[playerId].stopVideo();
      setAsPaused(videoData); // in case the video is already paused
      break;
    case 'background':
      videoPlayers[playerId].mute();
      setBackgroundVideo(playerId);
      break;
  }

  $videoWrapper.removeClass(classesToRemove);
}

function getVideoOptions(evt) {
  return videos[evt.target.a.id];
}

function toggleExpandVideo(playerId, expand) {
  const video = videos[playerId];
  const elementTop = video.$videoWrapper.offset().top;
  let offset = 0;
  let newHeight = 0;

  if (isMobile()) {
    video.$videoWrapper.parent().toggleClass('page-width', !expand);
  }

  if (expand) {
    if (isMobile()) {
      newHeight = $(window).width() / videoOptions.ratio;
    } else {
      newHeight = video.$videoWrapper.width() / videoOptions.ratio;
    }
    offset = ($(window).height() - newHeight) / 2;

    video.$videoWrapper
    .removeClass(classes.wrapperMinHeight)
    .animate({height: newHeight}, 600);

    // Animate doesn't work in mobile editor, so we don't use it
    if (!(isMobile() && Shopify.designMode)) {
      $('html, body').animate(
        {
          scrollTop: elementTop - offset,
        },
        videoOptions.scrollAnimationDuration,
      );
        }
        } else {
        if (isMobile()) {
        newHeight = video.$videoWrapper.data('mobile-height');
      } else {
        newHeight = video.$videoWrapper.data('desktop-height');
      }

      video.$videoWrapper
      .height(video.$videoWrapper.width() / videoOptions.ratio)
      .animate({height: newHeight}, 600);
      setTimeout(() => {
                 video.$videoWrapper.addClass(classes.wrapperMinHeight);
    }, 600);
  }
}

function togglePause(playerId) {
  const $pauseButton = videos[playerId].$videoWrapper.find(
    selectors.pauseVideoBtn,
  );
    if ($pauseButton.hasClass(classes.userPaused)) {
    $pauseButton.removeClass(classes.userPaused);
    customPlayVideo(playerId);
  } else {
    $pauseButton.addClass(classes.userPaused);
    pauseVideo(playerId);
  }
}

function startVideoOnClick(playerId) {
  const video = videos[playerId];

  // add loading class to wrapper
  video.$videoWrapper.addClass(classes.loading);

  // Explicity set the video wrapper height (needed for height transition)
  video.$videoWrapper.attr(
    'style',
    `height: ${video.$videoWrapper.height()}px`,
  );

    video.status = 'open';

    switch (video.type) {
    case 'image_with_play':
    privatePlayVideo(playerId, true);
    break;
    case 'background':
    unsetBackgroundVideo(playerId, video);
    videoPlayers[playerId].unMute();
    privatePlayVideo(playerId, true);
    break;
  }

  toggleExpandVideo(playerId, true);

  // esc to close video player
  $(document).on('keydown.videoPlayer', (evt) => {
    const playerId = $(document.activeElement).data('controls');
    if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
      return;
    }

    closeVideo(playerId);
    toggleExpandVideo(playerId, false);
  });
}

function sizeBackgroundVideos() {
  $(`.${classes.backgroundVideo}`).each((index, el) => {
    sizeBackgroundVideo($(el));
  });
}

function sizeBackgroundVideo($videoPlayer) {
  if (!youtubeLoaded) {
    return;
  }

  if (isMobile()) {
    $videoPlayer.removeAttr('style');
  } else {
    const $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
    const videoWidth = $videoWrapper.width();
    let playerWidth = $videoPlayer.width();
    let desktopHeight = $videoWrapper.data('desktop-height');

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (videoWidth / videoOptions.ratio < desktopHeight) {
      playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
      $videoPlayer
      .width(playerWidth)
      .height(desktopHeight)
      .css({
        left: (videoWidth - playerWidth) / 2,
        top: 0,
      }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
      $videoPlayer
      .width(videoWidth)
      .height(desktopHeight)
      .css({
        left: 0,
        top: (desktopHeight - desktopHeight) / 2,
      }); // player height is greater, offset top; reset left
    }

    $videoPlayer.prepareTransition();
    $videoWrapper.addClass(classes.loaded);
  }
}

function unsetBackgroundVideo(playerId) {
  // Switch the background video to a chrome-only player once played
  $(`#${playerId}`)
  .removeClass(classes.backgroundVideo)
  .addClass(classes.videoWithImage);

  setTimeout(() => {
             $(`#${playerId}`).removeAttr('style');
}, 600);

videos[playerId].$videoWrapper
.removeClass(classes.backgroundVideoWrapper)
.addClass(classes.playing);

videos[playerId].status = 'open';
}

function setBackgroundVideo(playerId) {
$(`#${playerId}`)
             .removeClass(classes.videoWithImage)
  .addClass(classes.backgroundVideo);

  videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);

  videos[playerId].status = 'background';
  sizeBackgroundVideo($(`#${playerId}`));
}

function isMobile() {
  return $(window).width() < 750 || window.mobileCheck();
}

function initEvents() {
  $(document).on('click.videoPlayer', selectors.playVideoBtn, (evt) => {
    const playerId = $(evt.currentTarget).data('controls');

    startVideoOnClick(playerId);
  });

  $(document).on('click.videoPlayer', selectors.closeVideoBtn, (evt) => {
    const playerId = $(evt.currentTarget).data('controls');

    $(evt.currentTarget).blur();
    closeVideo(playerId);
    toggleExpandVideo(playerId, false);
  });

  $(document).on('click.videoPlayer', selectors.pauseVideoBtn, (evt) => {
    const playerId = $(evt.currentTarget).data('controls');
    togglePause(playerId);
  });

  // Listen to resize to keep a background-size:cover-like layout
  $(window).on(
    'resize.videoPlayer',
    $.debounce(200, () => {
               if (!youtubeLoaded) { return; }
    let key;
    const fullscreen = window.innerHeight === screen.height;

    sizeBackgroundVideos();

  if (isMobile()) {
    for (key in videos) {
      if (videos.hasOwnProperty(key)) {
        if (videos[key].$videoWrapper.hasClass(classes.playing)) {
          if (!fullscreen) {
            pauseVideo(key);
            setAsPaused(videos[key]);
          }
        }
        videos[key].$videoWrapper.height(
          $(document).width() / videoOptions.ratio,
        );
          }
          }
          setAutoplaySupport(false);
      } else {
        setAutoplaySupport(true);
        for (key in videos) {
          if (
            videos[key].$videoWrapper.find(`.${classes.videoWithImage}`)
            .length
          ) {
            continue;
          }
          videoPlayers[key].playVideo();
          setAsPlaying(videos[key]);
        }
      }
    }),
      );

    $(window).on(
      'scroll.videoPlayer',
      $.debounce(50, () => {
                 if (!youtubeLoaded) { return; }

      for (const key in videos) {
      if (videos.hasOwnProperty(key)) {
        const $videoWrapper = videos[key].$videoWrapper;

        // Close the video if more than 75% of it is scrolled out of view
        if (
          $videoWrapper.hasClass(classes.playing) &&
          ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
           $(window).scrollTop() ||
           $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
           $(window).scrollTop() + $(window).height())
        ) {
          closeVideo(key);
          toggleExpandVideo(key, false);
        }
      }
    }
  }),
    );
}

function createPlayer(key) {
  const args = $.extend({}, videoOptions, videos[key]);
  args.playerVars.controls = args.controls;
  videoPlayers[key] = new YT.Player(key, args);
}

function removeEvents() {
  $(document).off('.videoPlayer');
  $(window).off('.videoPlayer');
}

return {
  init,
  editorLoadVideo,
  loadVideos,
  playVideo: customPlayVideo,
  pauseVideo,
  removeEvents,
};
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  const selectors = {
    statusMessage: '[data-form-status]',
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) { return; }

    this.$statusMessage.attr('tabindex', -1).focus();

    this.$statusMessage.on('blur', handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr('tabindex');
  }

  return {
    init,
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  const $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  const selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading',
  };

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading);
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginHeading = $(selectors.LoginHeading);

    // Show reset password form
    $('#RecoverPassword').on(
      'click',
      (evt) => {
        evt.preventDefault();
        showRecoverPasswordForm();
        this.$RecoverHeading.attr('tabindex', '-1').focus();
      },
    );

      // Hide reset password form
      $('#HideRecoverPasswordLink').on(
      'click',
      (evt) => {
        evt.preventDefault();
        hideRecoverPasswordForm();
        this.$LoginHeading.attr('tabindex', '-1').focus();
      },
    );

      this.$RecoverHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });

    this.$LoginHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('hide');
    $('#CustomerLoginForm').addClass('hide');

    if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
      this.$RecoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    const $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess')
    .removeClass('hide')
    .focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    const $newAddressForm = $('#AddressNewForm');
    const $newAddressFormButton = $('#AddressNewButton');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew',
        },
      );
        }

        // Initialize each edit form's country/province selector
        $('.address-country-option').each(function() {
        const formId = $(this).data('form-id');
        const countrySelector = `AddressCountry_${formId}`;
        const provinceSelector = `AddressProvince_${formId}`;
        const containerSelector = `AddressProvinceContainer_${formId}`;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector,
        });
      });

      // Toggle new/edit address forms
      $('.address-new-toggle').on('click', () => {
                                  const isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';

      $newAddressForm.toggleClass('hide');
      $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-edit-toggle').on('click', function() {
      const formId = $(this).data('form-id');
      const $editButton = $(`#EditFormButton_${formId}`);
      const $editAddress = $(`#EditAddress_${formId}`);
      const isExpanded = $editButton.attr('aria-expanded') === 'true';

      $editAddress.toggleClass('hide');
      $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-delete').on('click', function() {
      const $el = $(this);
      const formId = $el.data('form-id');
      const confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?',
        )
        ) {
        Shopify.postLink(`/account/addresses/${formId}`, {
parameters: {_method: 'delete'},
});
}
});
}

/**
*
*  Check URL for reset password hash
*
*/
function checkUrlHash() {
const hash = window.location.hash;

// Allow deep linking to recover password form
if (hash === '#recover') {
showRecoverPasswordForm.bind(this)();
}
}

return {
init() {
initEventListeners();
checkUrlHash();
resetPasswordSuccess();
customerAddressForm();
},
};
})();


/*= =============== SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
const selectors = {
edit: '.js-edit-toggle',
inputQty: '.cart__qty-input',
thumbnails: '.cart__image',
item: '.cart__row',
};

const config = {
showClass: 'cart__update--show',
showEditClass: 'cart__edit--active',
cartNoCookies: 'cart--no-cookies',
};

function Cart(container) {
this.$container = $(container);
this.$edit = $(selectors.edit, this.$container);
this.$inputQuantities = $(selectors.inputQty, this.$container);
this.$thumbnails = $(selectors.thumbnails, this.$container);

if (!this.cookiesEnabled()) {
this.$container.addClass(config.cartNoCookies);
}

this.$edit.on('click', this._onEditClick);
this.$inputQuantities.on('change', this._handleInputQty);

this.$thumbnails.css('cursor', 'pointer');
this.$thumbnails.on('click', this._handleThumbnailClick);
}

Cart.prototype = _.assignIn({}, Cart.prototype, {
onUnload() {
this.$edit.off('click', this._onEditClick);
},

_onEditClick(evt) {
const $evtTarget = $(evt.target);
const $updateLine = $(`.${$evtTarget.data('target')}`);
const isExpanded = $evtTarget.attr('aria-expanded') === 'true';

$evtTarget
.toggleClass(config.showEditClass)
.attr('aria-expanded', !isExpanded);
$updateLine.toggleClass(config.showClass);
},

_handleInputQty(evt) {
const $input = $(evt.target);
const value = $input.val();
const itemKey = $input.data('quantity-item');
const $itemQtyInputs = $(`[data-quantity-item=${itemKey}]`);
$itemQtyInputs.val(value);
},

_handleThumbnailClick(evt) {
const url = $(evt.target).data('item-url');

window.location.href = url;
},

cookiesEnabled() {
let cookieEnabled = navigator.cookieEnabled;

if (!cookieEnabled) {
document.cookie = 'testcookie';
cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
}
return cookieEnabled;
},
});

return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
const settings = {
// Breakpoints from src/stylesheets/global/variables.scss.liquid
mediaQueryMediumUp: 'screen and (min-width: 750px)',
};

const constants = {
SORT_BY: 'sort_by',
};

const selectors = {
mainContent: '#MainContent',
filterSelection: '#FilterTags',
sortSelection: '#SortBy',
};

const data = {
sortBy: 'data-default-sortby',
};

function Filters(container) {
const $container = (this.$container = $(container));

this.$filterSelect = $(selectors.filterSelection, $container);
this.$sortSelect = $(selectors.sortSelection, $container);
this.$selects = $(selectors.filterSelection, $container).add(
$(selectors.sortSelection, $container),
);

this.defaultSort = this._getDefaultSortValue();
this.$selects.removeClass('hidden');

this.$filterSelect.on('change', this._onFilterChange.bind(this));
this.$sortSelect.on('change', this._onSortChange.bind(this));
this._initBreakpoints();
}

Filters.prototype = _.assignIn({}, Filters.prototype, {
_initBreakpoints() {
const self = this;

enquire.register(settings.mediaQueryMediumUp, {
match() {
self._resizeSelect(self.$selects);
},
});
},

_onSortChange() {
const sort = this._sortValue();
const url = window.location.href.replace(window.location.search, '');
const queryStringValue = slate.utils.getParameterByName('q');
let query = queryStringValue !== null ? queryStringValue : '';

if (sort.length) {
const urlStripped = url.replace(window.location.hash, '');
query = query !== '' ? `?q=${query}&` : '?';

window.location.href =
urlStripped + query + sort + selectors.mainContent;
} else {
// clean up our url if the sort value is blank for default
window.location.href = url;
}
},

_onFilterChange() {
const filter = this._getFilterValue();

// remove the 'page' parameter to go to the first page of results
let search = document.location.search.replace(/\?(page=\w+)?&?/, '');

// only add the search parameters to the url if they exist
search = search !== '' ? `?${search}` : '';

document.location.href = filter + search + selectors.mainContent;
},

_getFilterValue() {
return this.$filterSelect.val();
},

_getSortValue() {
return this.$sortSelect.val() || this.defaultSort;
},

_getDefaultSortValue() {
return this.$sortSelect.attr(data.sortBy);
},

_sortValue() {
const sort = this._getSortValue();
let query = '';

if (sort !== this.defaultSort) {
query = `${constants.SORT_BY}=${sort}`;
}

return query;
},

_resizeSelect($selection) {
$selection.each(function() {
const $this = $(this);
const arrowWidth = 10;
// create test element
const text = $this.find('option:selected').text();
const $test = $('<span>').html(text);

// add to body, get width, and get out
$test.appendTo('body');
const width = $test.width();
$test.remove();

// set select width
$this.width(width + arrowWidth);
});
},

onUnload() {
this.$filterSelect.off('change', this._onFilterChange);
this.$sortSelect.off('change', this._onSortChange);
},
});

return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
function Header() {
theme.Header.init();
theme.MobileNav.init();
theme.Search.init();
}

Header.prototype = _.assignIn({}, Header.prototype, {
onUnload() {
theme.Header.unload();
},
});

return Header;
})();

theme.Maps = (function() {
const config = {
zoom: 14,
};
let apiStatus = null;
const mapsToLoad = [];

const errors = {
addressNoResults: theme.strings.addressNoResults,
addressQueryLimit: theme.strings.addressQueryLimit,
addressError: theme.strings.addressError,
authError: theme.strings.authError,
};

const selectors = {
section: '[data-section-type="map"]',
map: '[data-map]',
mapOverlay: '[data-map-overlay]',
};

const classes = {
mapError: 'map-section--load-error',
errorMsg: 'map-section__error errors text-center',
};

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
window.gm_authFailure = function() {
if (!Shopify.designMode) {
return;
}

$(selectors.section).addClass(classes.mapError);
$(selectors.map).remove();
$(selectors.mapOverlay).after(
`<div class="${
      classes.errorMsg
    }">${
      theme.strings.authError
    }</div>`,
      );
    };

      function Map(container) {
      this.$container = $(container);
      this.$map = this.$container.find(selectors.map);
      this.key = this.$map.data('api-key');

      if (typeof this.key === 'undefined') {
      return;
    }

      if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
      apiStatus = 'loading';
      if (typeof window.google === 'undefined') {
      $.getScript(
      `https://maps.googleapis.com/maps/api/js?key=${this.key}`,
).then(() => {
apiStatus = 'loaded';
initAllMaps();
});
}
}
}
}

function initAllMaps() {
// API has loaded, load all Map instances in queue
$.each(mapsToLoad, (index, instance) => {
instance.createMap();
});
}

function geolocate($map) {
const deferred = $.Deferred();
const geocoder = new google.maps.Geocoder();
const address = $map.data('address-setting');

geocoder.geocode({address}, (results, status) => {
if (status !== google.maps.GeocoderStatus.OK) {
deferred.reject(status);
}

deferred.resolve(results);
});

return deferred;
}

Map.prototype = _.assignIn({}, Map.prototype, {
createMap() {
const $map = this.$map;

return geolocate($map)
.then(
(results) => {
const mapOptions = {
zoom: config.zoom,
center: results[0].geometry.location,
draggable: false,
clickableIcons: false,
scrollwheel: false,
disableDoubleClickZoom: true,
disableDefaultUI: true,
};

const map = (this.map = new google.maps.Map($map[0], mapOptions));
const center = (this.center = map.getCenter());

// eslint-disable-next-line no-unused-vars
const marker = new google.maps.Marker({
map,
position: map.getCenter(),
});

google.maps.event.addDomListener(
window,
'resize',
$.debounce(250, () => {
google.maps.event.trigger(map, 'resize');
map.setCenter(center);
$map.removeAttr('style');
}),
);
},
)
.fail(() => {
let errorMessage;

switch (status) {
case 'ZERO_RESULTS':
errorMessage = errors.addressNoResults;
break;
case 'OVER_QUERY_LIMIT':
errorMessage = errors.addressQueryLimit;
break;
case 'REQUEST_DENIED':
errorMessage = errors.authError;
break;
default:
errorMessage = errors.addressError;
break;
}

// Show errors only to merchant in the editor.
if (Shopify.designMode) {
$map
.parent()
.addClass(classes.mapError)
.html(
`<div class="${
      classes.errorMsg
    }">${
      errorMessage
    }</div>`,
      );
    }
    });
    },

        onUnload() {
      if (this.$map.length === 0) {
      return;
    }
      google.maps.event.clearListeners(this.map, 'resize');
    },
    });

      return Map;
    })();

      /* eslint-disable no-new */
      theme.Product = (function() {
      function Product(container) {
      const $container = (this.$container = $(container));
      const sectionId = $container.attr('data-section-id');

      this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
        mediaQuerySmall: 'screen and (max-width: 749px)',
          bpSmall: false,
            enableHistoryState: $container.data('enable-history-state') || false,
              namespace: `.slideshow-${sectionId}`,
                sectionId,
                sliderActive: false,
                  zoomEnabled: false,
    };

      this.selectors = {
        addToCart: `#AddToCart-${sectionId}`,
        addToCartText: `#AddToCartText-${sectionId}`,
        errorQuantityMessage: `#error-quantity-${sectionId}`,
        quantity: `#Quantity-${sectionId}`,
        SKU: '.variant-sku',
        productStatus: '[data-product-status]',
        originalSelectorId: `#ProductSelect-${sectionId}`,
        productImageWraps: '.product-single__photo',
        productThumbImages: `.product-single__thumbnail--${sectionId}`,
        productThumbs: `.product-single__thumbnails-${sectionId}`,
        productThumbListItem: '.product-single__thumbnails-item',
        productFeaturedImage: '.product-featured-img',
        productThumbsWrapper: '.thumbnails-wrapper',
        saleLabel: `.product-price__sale-label-${sectionId}`,
        singleOptionSelector: `.single-option-selector-${sectionId}`,
        shopifyPaymentButton: '.shopify-payment-button',
        priceContainer: '[data-price]',
        regularPrice: '[data-regular-price]',
        salePrice: '[data-sale-price]',
      };

      this.classes = {
        hidden: 'hide',
        productOnSale: 'price--on-sale',
        productUnavailable: 'price--unavailable',
        activeClass: 'active-thumb',
      };

      // Stop parsing if we don't have the product json script tag when loading
      // section in the Theme Editor
      if (!$(`#ProductJson-${sectionId}`).html()) {
        return;
      }

      this.productSingleObject = JSON.parse(
        document.getElementById(`ProductJson-${sectionId}`).innerHTML,
      );

        this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
        'js-zoom-enabled',
      );

        this._initBreakpoints();
      this._stringOverrides();
      this._initVariants();
      this._initImageSwitch();
      this._initAddToCart();
      this._setActiveThumbnail();
    }

                            Product.prototype = _.assignIn({}, Product.prototype, {
                            _stringOverrides() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

      _initBreakpoints() {
        const self = this;

        enquire.register(this.settings.mediaQuerySmall, {
          match() {
            // initialize thumbnail slider on mobile if more than three thumbnails
            if ($(self.selectors.productThumbImages).length > 3) {
              self._initThumbnailSlider();
            }

            // destroy image zooming if enabled
            if (self.settings.zoomEnabled) {
              $(self.selectors.productImageWraps).each(function() {
                _destroyZoom(this);
              });
            }

            self.settings.bpSmall = true;
          },
          unmatch() {
            if (self.settings.sliderActive) {
              self._destroyThumbnailSlider();
            }

            self.settings.bpSmall = false;
          },
        });

        enquire.register(this.settings.mediaQueryMediumUp, {
          match() {
            if (self.settings.zoomEnabled) {
              $(self.selectors.productImageWraps).each(function() {
                _enableZoom(this);
              });
            }
          },
        });
      },

        _initVariants() {
          const options = {
            $container: this.$container,
            enableHistoryState:
            this.$container.data('enable-history-state') || false,
            singleOptionSelector: this.selectors.singleOptionSelector,
            originalSelectorId: this.selectors.originalSelectorId,
            product: this.productSingleObject,
          };

          this.variants = new slate.Variants(options);

          this.$container.on(
            `variantChange${this.settings.namespace}`,
            this._updateAvailability.bind(this),
          );
            this.$container.on(
            `variantImageChange${this.settings.namespace}`,
this._updateImages.bind(this),
);
this.$container.on(
`variantPriceChange${this.settings.namespace}`,
this._updatePrice.bind(this),
);
this.$container.on(
`variantSKUChange${this.settings.namespace}`,
this._updateSKU.bind(this),
);
},

_initImageSwitch() {
if (!$(this.selectors.productThumbImages).length) {
return;
}

const self = this;

$(this.selectors.productThumbImages)
.on('click', function(evt) {
evt.preventDefault();
const $el = $(this);

const imageId = $el.data('thumbnail-id');

self._switchImage(imageId);
self._setActiveThumbnail(imageId);
})
.on('keyup', self._handleImageFocus.bind(self));
},

_initAddToCart() {
const self = this;
const $quantityInput = $(self.selectors.quantity);

if ($quantityInput.length === 0) { return; }

$(self.selectors.addToCart).on('click', (evt) => {
const isInvalidQuantity = $quantityInput.val() <= 0;

$(self.selectors.errorQuantityMessage).toggleClass(
self.classes.hidden,
!isInvalidQuantity,
);

if (isInvalidQuantity) {
$quantityInput
.attr(
'aria-describedby',
`error-quantity-${self.settings.sectionId}`,
)
.attr('aria-invalid', true);
$(self.selectors.errorQuantityMessage).focus();
evt.preventDefault();
} else {
$quantityInput
.removeAttr('aria-describedby')
.removeAttr('aria-invalid');
}
});
},

_setActiveThumbnail(imageId) {
// If there is no element passed, find it by the current product image
if (typeof imageId === 'undefined') {
imageId = $(
`${this.selectors.productImageWraps}:not(.hide)`,
this.$container,
).data('image-id');
}

const $thumbnailWrappers = $(
`${this.selectors.productThumbListItem}:not(.slick-cloned)`,
this.$container,
);

const $activeThumbnail = $thumbnailWrappers.find(
`${this.selectors.productThumbImages
  }[data-thumbnail-id='${
    imageId
    }']`,
    );

    $(this.selectors.productThumbImages)
    .removeClass(this.classes.activeClass)
    .removeAttr('aria-current');

    $activeThumbnail.addClass(this.classes.activeClass);
    $activeThumbnail.attr('aria-current', true);

    if (!$thumbnailWrappers.hasClass('slick-slide')) {
    return;
    }

    const slideIndex = $activeThumbnail.parent().data('slick-index');

    $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage(imageId) {
    const $newImage = $(
    `${this.selectors.productImageWraps}[data-image-id='${imageId}']`,
this.$container,
);
const $otherImages = $(
`${this.selectors.productImageWraps
  }:not([data-image-id='${
         imageId
         }'])`,
         this.$container,
         );

         $newImage.removeClass(this.classes.hidden);
         $otherImages.addClass(this.classes.hidden);
         },

         _handleImageFocus(evt) {
         if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) { return; }

         $(`${this.selectors.productFeaturedImage}:visible`).focus();
},

_initThumbnailSlider() {
const options = {
slidesToShow: 4,
slidesToScroll: 3,
infinite: false,
prevArrow: `.thumbnails-slider__prev--${this.settings.sectionId}`,
nextArrow: `.thumbnails-slider__next--${this.settings.sectionId}`,
responsive: [
{
breakpoint: 321,
settings: {
slidesToShow: 3,
},
},
],
};

$(this.selectors.productThumbs).slick(options);

// Accessibility concerns not yet fixed in Slick Slider
$(this.selectors.productThumbsWrapper, this.$container)
.find('.slick-list')
.removeAttr('aria-live');
$(this.selectors.productThumbsWrapper, this.$container)
.find('.slick-disabled')
.removeAttr('aria-disabled');

this.settings.sliderActive = true;
},

_destroyThumbnailSlider() {
$(this.selectors.productThumbs).slick('unslick');
this.settings.sliderActive = false;

// Accessibility concerns not yet fixed in Slick Slider
$(this.selectors.productThumbsWrapper, this.$container)
.find('[tabindex="-1"]')
.removeAttr('tabindex');
},

_liveRegionText(variant) {
// Dummy content for live region
let liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

if (!variant) {
liveRegionText = theme.strings.unavailable;
return liveRegionText;
}

// Update availability
const availability = variant.available ? '' : `${theme.strings.soldOut},`;
liveRegionText = liveRegionText.replace('[Availability]', availability);

// Update pricing information
let regularLabel = '';
let regularPrice = theme.Currency.formatMoney(
variant.price,
theme.moneyFormat,
);
let saleLabel = '';
let salePrice = '';

if (variant.compare_at_price > variant.price) {
regularLabel = theme.strings.regularPrice;
regularPrice =
`${theme.Currency.formatMoney(
         variant.compare_at_price,
         theme.moneyFormat,
         )},`;
saleLabel = theme.strings.sale;
salePrice = theme.Currency.formatMoney(
variant.price,
theme.moneyFormat,
);
}

liveRegionText = liveRegionText
.replace('[Regular]', regularLabel)
.replace('[$$]', regularPrice)
.replace('[Sale]', saleLabel)
.replace('[$]', salePrice)
.trim();

return liveRegionText;
},

_updateLiveRegion(evt) {
const variant = evt.variant;
const liveRegion = this.container.querySelector(
this.selectors.productStatus,
);
liveRegion.textContent = this._liveRegionText(variant);
liveRegion.setAttribute('aria-hidden', false);

// hide content from accessibility tree after announcement
setTimeout(() => {
liveRegion.setAttribute('aria-hidden', true);
}, 1000);
},

_updateAddToCart(evt) {
const variant = evt.variant;

if (variant) {
if (variant.available) {
$(this.selectors.addToCart).prop('disabled', false);
$(this.selectors.addToCartText).text(theme.strings.addToCart);
$(this.selectors.shopifyPaymentButton, this.$container).show();

} else {
console.log('hi');
// The variant doesn't exist, disable submit button and change the text.
// This may be an error or notice that a specific variant is not available.
$(this.selectors.addToCart).prop('disabled', true);
$(this.selectors.addToCartText).text(theme.strings.soldOut);
$(this.selectors.shopifyPaymentButton, this.$container).hide();
}
} else {
$(this.selectors.addToCart).prop('disabled', true);
$(this.selectors.addToCartText).text(theme.strings.unavailable);
$(this.selectors.shopifyPaymentButton, this.$container).hide();
}
},

_updateAvailability(evt) {
// update form submit
this._updateAddToCart(evt);
// update live region
this._updateLiveRegion(evt);

this._updatePrice(evt);
},

_updateImages(evt) {
const variant = evt.variant;
const imageId = variant.featured_image.id;

this._switchImage(imageId);
this._setActiveThumbnail(imageId);
},

_updatePrice(evt) {
const variant = evt.variant;

const $priceContainer = $(this.selectors.priceContainer, this.$container);
const $regularPrice = $(this.selectors.regularPrice, $priceContainer);
const $salePrice = $(this.selectors.salePrice, $priceContainer);

// Reset product price state
$priceContainer
.removeClass(this.classes.productUnavailable)
.removeClass(this.classes.productOnSale)
.removeAttr('aria-hidden');

// Unavailable
if (!variant) {
$priceContainer
.addClass(this.classes.productUnavailable)
.attr('aria-hidden', true);
return;
}

// On sale
if (variant.compare_at_price > variant.price) {
$regularPrice.html(
theme.Currency.formatMoney(
variant.compare_at_price,
theme.moneyFormat,
),
);
$salePrice.html(
theme.Currency.formatMoney(variant.price, theme.moneyFormat),
);
$priceContainer.addClass(this.classes.productOnSale);
} else {
// Regular price
$regularPrice.html(
theme.Currency.formatMoney(variant.price, theme.moneyFormat),
);
}
},

_updateSKU(evt) {
const variant = evt.variant;

// Update the sku
$(this.selectors.SKU).html(variant.sku);
},

onUnload() {
this.$container.off(this.settings.namespace);
},
});

function _enableZoom(el) {
const zoomUrl = $(el).data('zoom');
$(el).zoom({
url: zoomUrl,
});
}

function _destroyZoom(el) {
$(el).trigger('zoom.destroy');
}

return Product;
})();

theme.Quotes = (function() {
const config = {
mediaQuerySmall: 'screen and (max-width: 749px)',
mediaQueryMediumUp: 'screen and (min-width: 750px)',
slideCount: 0,
};
const defaults = {
accessibility: true,
arrows: false,
dots: true,
autoplay: false,
touchThreshold: 20,
slidesToShow: 1,
slidesToScroll: 1,
};

function Quotes(container) {
const $container = (this.$container = $(container));
const sectionId = $container.attr('data-section-id');
const wrapper = (this.wrapper = '.quotes-wrapper');
const slider = (this.slider = `#Quotes-${sectionId}`);
         const $slider = $(slider, wrapper);

         let sliderActive = false;
         const mobileOptions = $.extend({}, defaults, {
         slidesToShow: 1,
         slidesToScroll: 1,
         adaptiveHeight: true,
         });

         config.slideCount = $slider.data('count');

         // Override slidesToShow/Scroll if there are not enough blocks
         if (config.slideCount < defaults.slidesToShow) {
         defaults.slidesToShow = config.slideCount;
         defaults.slidesToScroll = config.slideCount;
         }

         $slider.on('init', this.a11y.bind(this));

         enquire.register(config.mediaQuerySmall, {
         match() {
         initSlider($slider, mobileOptions);
         },
         });

         enquire.register(config.mediaQueryMediumUp, {
         match() {
         initSlider($slider, defaults);
         },
         });

         function initSlider(sliderObj, args) {
         if (sliderActive) {
         sliderObj.slick('unslick');
         sliderActive = false;
         }

         sliderObj.slick(args);
         sliderActive = true;
         }
         }

         Quotes.prototype = _.assignIn({}, Quotes.prototype, {
         onUnload() {
         enquire.unregister(config.mediaQuerySmall);
         enquire.unregister(config.mediaQueryMediumUp);

         $(this.slider, this.wrapper).slick('unslick');
         },

         onBlockSelect(evt) {
         // Ignore the cloned version
         const $slide = $(
         `.quotes-slide--${evt.detail.blockId}:not(.slick-cloned)`,
);
const slideIndex = $slide.data('slick-index');

// Go to selected slide, pause autoplay
$(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
},

a11y(event, obj) {
const $list = obj.$list;
const $wrapper = $(this.wrapper, this.$container);

// Remove default Slick aria-live attr until slider is focused
$list.removeAttr('aria-live');

// When an element in the slider is focused set aria-live
$wrapper.on('focusin', (evt) => {
if ($wrapper.has(evt.target).length) {
$list.attr('aria-live', 'polite');
}
});

// Remove aria-live
$wrapper.on('focusout', (evt) => {
if ($wrapper.has(evt.target).length) {
$list.removeAttr('aria-live');
}
});
},
});

return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
function SlideshowSection(container) {
const $container = (this.$container = $(container));
const sectionId = $container.attr('data-section-id');
const slideshow = (this.slideshow = `#Slideshow-${sectionId}`);

         theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
        }

        return SlideshowSection;
        })();

          theme.SlideshowSection.prototype = _.assignIn(
            {},
            theme.SlideshowSection.prototype,
            {
              onUnload() {
                delete theme.slideshows[this.slideshow];
              },

              onBlockSelect(evt) {
                const $slideshow = $(this.slideshow);
                const adaptHeight = $slideshow.data('adapt-height');

                if (adaptHeight) {
                  theme.slideshows[this.slideshow].setSlideshowHeight();
                }

                // Ignore the cloned version
                const $slide = $(
                  `.slideshow__slide--${evt.detail.blockId}:not(.slick-cloned)`,
                );
                  const slideIndex = $slide.data('slick-index');

                // Go to selected slide, pause auto-rotate
                $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
              },

              onBlockDeselect() {
                // Resume auto-rotate
                $(this.slideshow).slick('slickPlay');
              },
            },
          );

            theme.slideshows = {};

            theme.VideoSection = (function() {
            function VideoSection(container) {
              const $container = (this.$container = $(container));

              $('.video', $container).each(function() {
                const $el = $(this);
                theme.Video.init($el);
                theme.Video.editorLoadVideo($el.attr('id'));
              });
            }

            return VideoSection;
          })();

          theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
            onUnload() {
              theme.Video.removeEvents();
            },
          });


          $(document).ready(() => {
                            const sections = new theme.Sections();

          sections.register('cart-template', theme.Cart);
          sections.register('product', theme.Product);
          sections.register('collection-template', theme.Filters);
          sections.register('product-template', theme.Product);
          sections.register('header-section', theme.HeaderSection);
          sections.register('map', theme.Maps);
          sections.register('slideshow-section', theme.SlideshowSection);
          sections.register('video-section', theme.VideoSection);
          sections.register('quotes', theme.Quotes);
        });

    theme.init = function() {
      theme.customerTemplates.init();

      // Theme-specific selectors to make tables scrollable
      const tableSelectors = '.rte table,' + '.custom__item-inner--html table';

      slate.rte.wrapTable({
        $tables: $(tableSelectors),
        tableWrapperClass: 'scrollable-wrapper',
      });

      // Theme-specific selectors to make iframes responsive
      const iframeSelectors =
            '.rte iframe[src*="youtube.com/embed"],' +
            '.rte iframe[src*="player.vimeo"],' +
            '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
            '.custom__item-inner--html iframe[src*="player.vimeo"]';

      slate.rte.wrapIframe({
        $iframes: $(iframeSelectors),
        iframeWrapperClass: 'video-wrapper',
      });

      // Common a11y fixes
      slate.a11y.pageLinkFocus($(window.location.hash));

      $('.in-page-link').on('click', (evt) => {
        slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
      });

      $('a[href="#"]').on('click', (evt) => {
        evt.preventDefault();
      });

      slate.a11y.accessibleLinks({
        messages: {
          newWindow: theme.strings.newWindow,
          external: theme.strings.external,
          newWindowExternal: theme.strings.newWindowExternal,
        },
        $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)'),
      });

      theme.FormStatus.init();
    };

    $(theme.init);
